export default {
  nameFormat(sFirstname?: string | null, sLastname?: string | null): string | undefined {
    if (!sFirstname && !sLastname) {
      return undefined;
    }
    if (!sFirstname) {
      return sLastname ?? undefined;
    }
    if (!sLastname) {
      return sFirstname;
    }
    return `${sFirstname} ${sLastname}`;
  },

  addressFormat(sStreet?: string | null, sHouseNumber?: string | null, sZip?: string | null, sCountry?: string | null): string | undefined {
    if (!sZip && !sCountry) {
      return undefined;
    }
    if (!sStreet && !sHouseNumber) {
      return `${sZip} ${sCountry}`;
    }
    if (!sHouseNumber) {
      return `${sStreet}, ${sZip} ${sCountry}`;
    }
    return `${sStreet} ${sHouseNumber}, ${sZip} ${sCountry}`;
  },
};
